








import { Component, Provide, Vue } from "vue-property-decorator";
import { hotelInfo } from "@/config/host.config";

import { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { IHotelInfo } from "@/@types/hotel-info/info";

@Component({})
export default class HotelInfo extends Vue {
  @Provide("backgroundFolder") backgroundFolder = "hotel_info/backgrounds";
  @Provide("imageFolder") imageFolder = "hotel_info/image";

  infoList: Array<IHotelInfo> = [];

  deleted(id: string): void {
    const i = this.infoList.findIndex((el) => el._id === id);
    if (i != -1) {
      this.infoList.splice(i, 1);
      return;
    }
    this.startCreateHotelInfoList();
  }

  async updateInfo(data: Partial<IHotelInfo>, id: string): Promise<void> {
    const params: AxiosRequestConfig = {};
    const method = id ? "put" : "post";
    let url = hotelInfo.mainAPI;
    if (id) url = url + "/" + id;
    try {
      const onfoRes: AxiosResponse<IHotelInfo> = await this.$axios({
        method,
        url,
        data,
        params,
      });

      if (onfoRes.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        const i = this.infoList.findIndex((el) =>
          el._id === id ? id : onfoRes.data._id
        );
        if (i == -1) {
          this.startCreateHotelInfoList();
          return;
        }

        if (!id) {
          this.infoList.unshift(onfoRes.data);
          return;
        }

        const information = this.infoList.find((el) => el._id === id);
        if (!information) {
          this.startCreateHotelInfoList();
          return;
        }

        for (const key of Object.keys(data)) {
          if (
            data[key as keyof IHotelInfo] !=
            information[key as keyof IHotelInfo]
          )
            Vue.set(information, key, data[key as keyof IHotelInfo]);
        }
      }
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async getHotelInformation(): Promise<Array<IHotelInfo>> {
    const uri = hotelInfo.mainAPI;
    const config: AxiosRequestConfig = {
      params: { "match[deleted][value]": false },
    };
    return new Promise<Array<IHotelInfo>>((res, rej) => {
      this.$axios
        .get(uri, config)
        .then((infoRes: AxiosResponse<Array<IHotelInfo>>) => {
          if (infoRes.status === 200) res(infoRes.data);
        })
        .catch((error: AxiosError) => {
          rej(error);
        });
    });
  }

  startCreateHotelInfoList(): void {
    this.getHotelInformation()
      .then((info: Array<IHotelInfo>) => {
        this.infoList = info;
      })
      .catch((e: AxiosError) => console.log(e));
  }

  mounted(): void {
    this.startCreateHotelInfoList();
  }
}
